"use client";

import { ApiError } from "../api-client";
import { getClientToken, notifySessionExpired, refreshClientToken } from "../auth";
import { CLUB_API_URL } from "../club-api/internal";
import type { EditionId, OrganizerId, RegistrationState } from "../schemas/camp";

/** The roster filters the export honours: the same two the list has. */
export interface RosterFilter {
	q?: string;
	state?: RegistrationState;
}

export function rosterSearch(filter: RosterFilter, extra: Record<string, string> = {}): string {
	const params = new URLSearchParams(extra);
	if (filter.state !== undefined) params.set("state", filter.state);
	if (filter.q !== undefined && filter.q.trim() !== "") params.set("q", filter.q.trim());
	return params.toString();
}

function send(url: string, token: string | null): Promise<Response> {
	return fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
}

/**
 * The roster as a CSV file (`format=csv`, streamed by the server, no paging). A link cannot carry
 * the bearer token, so the portal fetches the bytes and hands them to the browser's download.
 */
export async function fetchRosterCsv(
	organizerId: OrganizerId,
	editionId: EditionId,
	filter: RosterFilter = {},
): Promise<Blob> {
	const url = `${CLUB_API_URL}/organizers/${organizerId}/editions/${editionId}/roster?${rosterSearch(filter, { format: "csv" })}`;
	let res = await send(url, getClientToken());
	if (res.status === 401) {
		const fresh = await refreshClientToken();
		if (fresh) res = await send(url, fresh);
	}
	if (res.status === 401) notifySessionExpired();
	if (!res.ok) throw new ApiError(res.status, await res.text());
	return res.blob();
}
